"use client";

import { Flame, Droplets, Gauge, Sprout, Waves, ArrowDownToLine, Wrench } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceCategories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const services = [{
    id: 2,
    title: "Fire Pumps & Heat Exchanges",
    icon: Flame,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/fire_pump_heat_exchange_service.png",
    description: "Fire pump systems and heat exchanger solutions"
  }, {
    id: 3,
    title: "Chill Water Pumps & Cooling Towers",
    icon: Droplets,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/chill_water_pump_cooling_tower.png",
    description: "Chill water pump and cooling tower maintenance"
  }, {
    id: 5,
    title: "Boiler Feed Pumps",
    icon: Gauge,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/boiler_feed_pump_service.png",
    description: "Boiler feed pump installation and repair"
  }, {
    id: 6,
    title: "Irrigation & Pool Services",
    icon: Sprout,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/irrigation_pool_service.png",
    description: "Comprehensive irrigation and pool system services"
  }, {
    id: 10,
    title: "Booster Pumps",
    icon: Waves,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/booster_pump_service.png",
    description: "Booster pump installation and maintenance"
  }, {
    id: 11,
    title: "Sewage Lift Stations",
    icon: ArrowDownToLine,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/sewage_lift_station_service.png",
    description: "Sewage lift station servicing and repair"
  }, {
    id: 13,
    title: "Line Shaft Turbines",
    icon: Wrench,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/line_shaft_turbine_service.png",
    description: "Line shaft turbine maintenance and repair"
  }, {
    id: 14,
    title: "Submersible Pumps",
    icon: Droplets,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/submersible_pump_service.png",
    description: "Submersible pump installation and service"
  }];
  return <section ref={ref} className={`relative py-20 bg-background transition-all duration-[350ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto px-6">
        {}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-display font-bold text-foreground mb-4">
            Water Pump Services
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Expert water pump solutions for commercial and residential applications
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className={`group cursor-pointer transition-all duration-[250ms] ease-[cubic-bezier(0.22,1,0.36,1)] hover:-translate-y-1 rounded-[12px] bg-light-background/60 backdrop-blur-md border border-muted shadow-[0_2px_8px_rgb(0_0_0_/_0.04),_0_1px_3px_rgb(0_0_0_/_0.08)] hover:shadow-[0_4px_16px_rgb(0_0_0_/_0.12),_0_2px_6px_rgb(0_0_0_/_0.08)] overflow-hidden ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
            animationDelay: `${i * 50}ms`
          }}>
                {}
                <div className="relative w-full aspect-[16/10] overflow-hidden">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-[350ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-dark-background/60 to-transparent"></div>
                </div>

                <CardHeader className="pb-3">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center transition-colors duration-[250ms] group-hover:bg-primary-300">
                      <Icon className="w-6 h-6 text-primary transition-colors duration-[250ms]" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-lg font-display font-semibold text-foreground">
                      {service.title}
                    </CardTitle>
                  </div>
                </CardHeader>

                <CardContent>
                  <CardDescription className="text-sm text-muted-foreground leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-primary via-accent to-secondary"></div>
    </section>;
}